import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { UserDataOutputDTO } from './userDataDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class UserServices {
  async getByAll(limit?: number, params = {}): Promise<UserDataOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/user/`, {
        headers: { 'authentication-token': getJWT()! },
        params: { ...params, limit: limit },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getUserRelations(hash_user = null) {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/user/relations/`, {
        headers: { 'authentication-token': getJWT()! },
        params: hash_user ? { hash_user } : {},
      })
      if (res.status >= 200) {
        return res.data
      }
      return null
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getBusinessUnitByHashUser(hash_user: string) {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/user-by-business-unit/by-hash/${hash_user}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      if (res.status >= 200) {
        return res.data
      }
      return null
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getWorkUnitByHashUser(hash_user: string) {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/user-by-work-unit/by-hash/${hash_user}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      if (res.status >= 200) {
        return res.data
      }
      return null
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getCurrencyByUser() {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/user/currencies/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const userServices = new UserServices()
